const enterpriseIds = {    
    delLearning_framework: 'DelLearningFramework',
    automation_mail: 'ATCI.LKM.Automation',
    industry_powers: 'IndustryPowers',
    automation_learn: 'GenAIAutomationLearn',
    automation_prime: 'AutomationPrimeHelp',
    automation_university: 'AutomationUniversity'
}

const contactUsPage = {
    veena: 'veena.oruganti',
    amrita: 'amrita.verma',
    devika: 'devika.gajanan.pote',
    sharda: 'sharda.mankare',
    marc: 'marc.harvie.l.calim',
    christopher: 'christopher.n.simon',
    racquel: 'racquel.ann.s.felix',
    ankita: 'ankita.ag.mishra',
    amrutha: 'amrutha.c.reddy',
    hemashree: 'hemashree.janardhan'    
}

const uploadDataComponent = {
    atci_lkm_lis_portal_developmemnt: 'ATCI.LKM.LIS.PORTALDEVELOPMENT'    
}

const domain = 'accenture.com';

const delLearningFramework = `${enterpriseIds.delLearning_framework}@${domain}`;
const automationMail = `${enterpriseIds.automation_mail}@${domain}`;
const industryPowers = `${enterpriseIds.industry_powers}@${domain}`;
const automationLearn = `${enterpriseIds.automation_learn}@${domain}`;
const automationPrime = `${enterpriseIds.automation_prime}@${domain}`;
const automationUniversity = `${enterpriseIds.automation_university}@${domain}`;

export default {
    delLearningFramework,automationMail,industryPowers,automationLearn,automationPrime,automationUniversity,contactUsPage,domain,
    uploadDataComponent
}